(() => {
  const root = document.querySelector('[data-chikas-product]');
  if (!root) return;

  const jsonEl = document.querySelector('[data-chikas-product-json]');
  let product = null;
  try {
    product = jsonEl ? JSON.parse(jsonEl.textContent) : null;
  } catch (_) {}

  const fullDescription = () => {
    const tpl = document.querySelector('[data-chikas-full-description]');
    if (tpl && tpl.innerHTML && tpl.innerHTML.trim()) {
      return tpl.innerHTML.trim();
    }
    if (!product) return '';
    const html = product.description || product.content || '';
    return String(html || '').trim();
  };

  const looksTruncated = (el) => {
    if (!el) return true;
    const text = (el.textContent || '').replace(/\s+/g, ' ').trim();
    if (!text) return true;
    if (/\.\.\.$/.test(text)) return true;
    if (text.length <= 140) return true;
    return false;
  };

  const polishDescriptionMarkup = (host) => {
    if (!host) return;
    const nodes = [...host.querySelectorAll('p')];
    if (!nodes.length) return;

    nodes.forEach((p, index) => {
      const raw = (p.textContent || '').replace(/\s+/g, ' ').trim();
      if (!raw) {
        p.remove();
        return;
      }

      const onlyStrong =
        p.childElementCount === 1 &&
        p.children[0] &&
        /^(STRONG|B)$/i.test(p.children[0].tagName) &&
        (p.textContent || '').trim() === (p.children[0].textContent || '').trim();
      const isKicker =
        index === 0 &&
        (onlyStrong || (/^[A-ZÁÉÍÓÚÜÑ0-9\s\/\-]{8,}$/.test(raw) && raw.length < 48));
      const isNote = /nota\s*:/i.test(raw) || raw.includes('🔔');

      p.classList.remove('chikas-desc-kicker', 'chikas-desc-line', 'chikas-desc-note');
      if (isKicker) {
        p.classList.add('chikas-desc-kicker');
        p.innerHTML = `<strong>${raw}</strong>`;
      } else if (isNote) {
        p.classList.add('chikas-desc-note');
      } else {
        p.classList.add('chikas-desc-line');
      }
    });
  };

  const ensureFullDescription = () => {
    const html = fullDescription();
    if (!html) return;

    let host = root.querySelector('[data-chikas-product-desc]');
    const legacy = root.querySelector(
      '.product-detail > .drawer-note, .product-detail p.drawer-note, .product-detail .detail-price + p, .product-detail .detail-price + .drawer-note'
    );

    if (!host && legacy) {
      host = document.createElement('div');
      host.className = 'product-detail__description rte';
      host.setAttribute('data-chikas-product-desc', 'js-full');
      legacy.replaceWith(host);
    }

    if (!host) {
      const price = root.querySelector('.detail-price');
      if (!price) return;
      host = document.createElement('div');
      host.className = 'product-detail__description rte';
      host.setAttribute('data-chikas-product-desc', 'js-full');
      price.insertAdjacentElement('afterend', host);
    }

    if (host.getAttribute('data-chikas-product-desc') === 'full-v4' && !looksTruncated(host)) {
      polishDescriptionMarkup(host);
      return;
    }

    if (looksTruncated(host) || host.getAttribute('data-chikas-product-desc') === 'js-full') {
      host.className = 'product-detail__description rte';
      host.setAttribute('data-chikas-product-desc', 'js-full');
      host.innerHTML = html;
    }

    polishDescriptionMarkup(host);
  };

  const hideDescriptionAccordion = () => {
    root.querySelectorAll('details').forEach((details) => {
      const summary = details.querySelector('summary');
      const title = ((summary && summary.textContent) || '').toLowerCase();
      if (title.includes('descripc') || title.includes('description')) {
        details.remove();
      }
    });
  };

  ensureFullDescription();
  hideDescriptionAccordion();

  const variantInput = root.querySelector('[data-chikas-variant-id]');
  const optionSelect = root.querySelector('[data-chikas-option]');
  const sizeLabel = root.querySelector('[data-chikas-selected-size]');
  const sizeBtns = [...root.querySelectorAll('[data-chikas-size]')];
  const buyNowBtn = root.querySelector('[data-chikas-buy-now]');
  const buyNowError = root.querySelector('[data-chikas-buy-now-error]');

  if (buyNowBtn && variantInput) {
    buyNowBtn.addEventListener('click', async () => {
      const id = Number(variantInput.value);
      if (!id || buyNowBtn.disabled) return;
      buyNowBtn.disabled = true;
      buyNowBtn.classList.add('is-busy');
      if (buyNowError) buyNowError.hidden = true;
      const shopRoot = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      try {
        const res = await fetch(`${shopRoot}cart/add.js`, {
          method: 'POST',
          credentials: 'same-origin',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: [{ id, quantity: 1 }] }),
        });
        if (!res.ok) throw new Error('add failed');
        window.location.href = `${shopRoot}checkout`;
      } catch (err) {
        buyNowBtn.disabled = false;
        buyNowBtn.classList.remove('is-busy');
        if (buyNowError) {
          buyNowError.textContent = 'No pudimos continuar con esta talla. Revisa la disponibilidad e intenta de nuevo.';
          buyNowError.hidden = false;
        }
      }
    });
  }

  const money = (cents) =>
    typeof window.ChikasMoney === 'function'
      ? window.ChikasMoney(cents)
      : (Number(cents) / 100).toLocaleString('es-CO', { style: 'currency', currency: 'COP' });

  const updatePrice = (variant) => {
    const box = root.querySelector('[data-chikas-price]');
    if (!box || !variant) return;
    const price = Number(variant.price) || 0;
    const compare = Number(variant.compare_at_price) || 0;
    const onSale = compare > price && price > 0;
    const current = box.querySelector('[data-chikas-price-current]');
    const was = box.querySelector('[data-chikas-price-compare]');
    const badge = box.querySelector('[data-chikas-price-badge]');
    if (current) current.textContent = money(price);
    box.classList.toggle('is-on-sale', onSale);
    if (was) {
      was.hidden = !onSale;
      was.textContent = onSale ? money(compare) : '';
    }
    if (badge) {
      badge.hidden = !onSale;
      badge.textContent = onSale ? `-${Math.round(((compare - price) / compare) * 100)}%` : '';
    }
  };

  const pickVariant = (value) => {
    if (!product || !variantInput) return;
    const variants = product.variants || [];
    const match =
      variants.find((v) => v.available && (v.option1 === value || v.option2 === value || v.option3 === value)) ||
      variants.find((v) => v.option1 === value || v.option2 === value || v.option3 === value);
    if (match) {
      variantInput.value = match.id;
      updatePrice(match);
      const btn = root.querySelector('.add-cart');
      if (btn) {
        btn.disabled = !match.available;
        if (!match.available) btn.textContent = 'Agotado';
      }
      if (buyNowBtn) buyNowBtn.disabled = !match.available;
    }
  };

  sizeBtns.forEach((btn) => {
    btn.addEventListener('click', () => {
      sizeBtns.forEach((b) => b.classList.remove('is-selected'));
      btn.classList.add('is-selected');
      const value = btn.getAttribute('data-value');
      if (sizeLabel) sizeLabel.textContent = value ? `· ${value}` : '';
      if (optionSelect) {
        optionSelect.value = value;
        optionSelect.dispatchEvent(new Event('change', { bubbles: true }));
      }
      pickVariant(value);
    });
  });

  // Guía de tallas: manejada por script inline en main-product.liquid

  const gallery = root.querySelector('.gallery');
  const count = root.querySelector('[data-gallery-count]');
  if (gallery && count) {
    const figures = gallery.querySelectorAll('figure');
    const total = figures.length || 1;
    const update = () => {
      const w = figures[0] ? figures[0].offsetWidth + 12 : 1;
      const n = Math.min(total, Math.max(1, Math.round(gallery.scrollLeft / w) + 1));
      count.textContent = `${n} / ${total}`;
    };
    gallery.addEventListener('scroll', update, { passive: true });
    update();
  }
})();
